import Tickets from 'Components/Tickets/Tickets'
import {getTicketsKeyword} from 'Containers/Tickets/selectors'
import {setTicketsKeyword} from 'Containers/Tickets/actions'
import {connect} from 'react-redux';

const mapDispatchToProps = (dispatch) => {
  return {
    setTicketsKeyword: keyword => dispatch(setTicketsKeyword(keyword))
  }
};
const mapStateToProps = (state) => {
  return {
    ticketsKeyword: getTicketsKeyword(state),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Tickets)
